import styled, { css } from "styled-components";
import { Track } from "Providers/ListProvider/types";

export const Player = ({ id, type }: Track) => {
  if (!id || !type) {
    return null;
  }

  let embedProps = {};
  if (["spotify", "spotify-artist"].includes(type)) {
    embedProps = {
      frameBorder: 0,
      allowFullScreen: true,
      allow:
        "autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture",
      loading: "lazy",
      src: `https://open.spotify.com/embed/${
        type === "spotify-artist" ? "artist" : "track"
      }/${id}?utm_source=generator`,
    };
  }
  if (type === "youtube") {
    embedProps = {
      frameBorder: 0,
      allowFullScreen: true,
      allow:
        "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
      src: `https://www.youtube.com/embed/${id}?color=white&rel=0`,
    };
  }
  if (type === "soundcloud") {
    embedProps = {
      frameBorder: 0,
      scrolling: "no",
      allow:
        "autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture",
      src: `https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/${id}&color=%231b0076&auto_play=false&hide_related=false&show_comments=true&show_user=true&show_reposts=false&show_teaser=true&visual=true`,
    };
  }
  return (
    <Wrapper isVideo={type === "youtube"}>
      <Iframe {...embedProps} />
    </Wrapper>
  );
};

const Iframe = styled.iframe`
  width: 100%;
  height: 100%;
  border-radius: 12px;
`;

const Wrapper = styled.div<{ isVideo?: boolean }>`
  display: block;
  position: relative;
  padding-bottom: 152px;
  width: 100%;
  ${(p) =>
    p.isVideo &&
    css`
      padding-bottom: 56.25%;
    `};
  ${Iframe} {
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
  }
`;
